import uuid from "react-uuid";

import { FieldRedzone } from "models";

export const getFieldRedzoneMocks = ({ confirmed }: { confirmed: boolean | null }): FieldRedzone[] => [
  {
    id: uuid(),
    fieldId: uuid(),
    redzoneId: uuid(),
    year: 2024,
    confirmed,
    field: {
      id: uuid(),
      number: "1",
      name: "Field 1",
    },
  },
  {
    id: uuid(),
    fieldId: uuid(),
    redzoneId: uuid(),
    year: 2024,
    confirmed,
    field: {
      id: uuid(),
      number: "2",
      name: "Field 2",
    },
  },
];
